import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { GeneralService } from 'src/app/services/general.service';
import { ToastService, MDBModalRef, IMyOptions, MDBModalService } from 'ng-uikit-pro-standard';
import { CustomerService } from 'src/app/services/customer.service';
import { Subject } from 'rxjs';

declare var $: any;
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-new-activity-generic',
  templateUrl: './new-activity-generic.component.html',
  styleUrls: ['./new-activity-generic.component.scss']
})
export class NewActivityGenericComponent implements OnInit {
  @Input() message: string = 'Message here...';
  action: Subject<any> = new Subject<any>();

  titleModalActivity: string;
  currentDate: any;
  empleoyees: any;
  activityType: any;

  ProjectId: any;
  TMPCusomerActivityId: any;
  public _formEntityActivity: FormGroup;

  public myDatePickerOptions: IMyOptions = {
    // Your options
  };
  constructor(
    private toast: ToastService,
    public modalRef: MDBModalRef,
    public GeneralService: GeneralService,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private modalService: MDBModalService,
    private translate:TranslateService


  ) {
    this.titleModalActivity = "New Activity"
    this.empleoyees = [];
    this.activityType = [];
  }

  ngOnInit() {
    let data: any;
    data = this.modalService.config.data;
    this.ProjectId = data.customerSelect;
    setTimeout(() => {
      $('.modal').css('overflow-y', 'auto');
    }, 1000);
    this.getcurrentDate();
    this.initForm();
    this.getDataToSelects();
    // get ProjectId

  }


  closeModal() {
    this.modalRef.hide();
  }

  initForm() {
    this._formEntityActivity = new FormGroup({
      // OptCustomer: new FormControl({ value: '', disabled: false }, []),
      // OptServiceSite: new FormControl({ value: '', disabled: false }, []),
      OptProject: new FormControl({ value: 1, disabled: false }, []),
      Hour: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
      // CustomerId: new FormControl({ value: '', disabled: false }, []),
      ProjectId: new FormControl({ value: '', disabled: false }, []),
      // CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
      EmployeeId: new FormControl({ value: '', disabled: false }, []),
      Type: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: '', disabled: false }, []),
      StartDateTime: new FormControl({ value: this.currentDate, disabled: false }, [Validators.required]),
      EndTime: new FormControl({ value: '', disabled: false }, []),
      Follow: new FormControl({ value: '', disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, []),
      Close: new FormControl({ value: '', disabled: false }, []),
      FollowComments: new FormControl({ value: '', disabled: false }, []),
    });
  }
  formNewAct() {
    this.titleModalActivity = 'New Activity';
    this._formEntityActivity = new FormGroup({
      OptProject: new FormControl({ value: 1, disabled: false }, []),
      Hour: new FormControl({ value: '', disabled: false }, [Validators.required]),
      Minute: new FormControl({ value: null, disabled: false }, [Validators.required]),
      //CustomerId: new FormControl({ value: '', disabled: true }, []),
      ProjectId: new FormControl({ value: '', disabled: false }, []),
      // CusomerActivityId: new FormControl({ value: 0, disabled: false }, []),
      EmployeeId: new FormControl({ value: 1, disabled: false }, []),
      Type: new FormControl({ value: 1, disabled: false }, [Validators.required]),
      Notes: new FormControl({ value: '', disabled: false }, []),
      StartDateTime: new FormControl({ value: this.currentDate, disabled: false }, [Validators.required]),
      EndTime: new FormControl({ value: '', disabled: false }, []),
      Follow: new FormControl({ value: '', disabled: false }, []),
      Name: new FormControl({ value: '', disabled: false }, []),
      Close: new FormControl({ value: '', disabled: false }, []),
      FollowComments: new FormControl({ value: '', disabled: false }, []),
    });
  }
  getcurrentDate() {
    let f = new Date();
    let month: string;
    let day: string;

    if ((f.getMonth() + 1) < 10) {
      month = '0' + (f.getMonth() + 1);
    } else {
      month = (f.getMonth() + 1) + '';
    }
    if ((f.getDate()) < 10) {
      day = '0' + (f.getDate());
    } else {
      day = (f.getDate()) + '';
    }
    this.currentDate = (f.getFullYear() + "-" + (month) + "-" + day);
  }
  getDataToSelects() {
    this.GeneralService.GetEmployees().subscribe(result => {
      this.empleoyees = result.map((val) => {
        return { // Return the new object structure
          label: val.CONTACTNAME, value: val.ID
        };
      });
      console.log('empleoyees', this.empleoyees);
    });
    this.GeneralService.getPopulateGeneral('Customer/GetCustomerActivityType').subscribe(result => {
      this.activityType = result.map((val) => {
        return { // Return the new object structure
          label: val.Name, value: val.ID
        };
      });
      console.log('activityType', this.activityType);
    });
  }

  sumitFormActivity() {
    let formValue;
    formValue = this._formEntityActivity.value;

    formValue.ProjectId = parseInt(this.ProjectId);
    // Change Format date 2020-07-16 to 20200715 11:11 (Concat hour)
    let TMPdate;
    let HourToedit;
    TMPdate = formValue.StartDateTime.replace('-', "");
    TMPdate = TMPdate.replace('-', "") + " " + formValue.Hour;
    HourToedit = formValue.Hour;
    formValue.StartDateTime = "";
    // "20200727T11:34:00 03:34"
     let minute = formValue.Minute;
    formValue.StartDateTime = TMPdate;
    formValue.Hour = parseInt(formValue.Minute.substr(0, 2));
    formValue.Minute = parseInt(minute.substr(3, 2));
    // Change boolean ton strin 0 and 1
    if (formValue.Follow === true) {
      formValue.Follow = parseInt('1');
    } else { formValue.Follow = parseInt('0'); }
    // Close
    if (formValue.Close === true) {
      formValue.Close = parseInt('1');
    } else { formValue.Close = parseInt('0'); }
    // END hange boolean ton strin 0 and 1
    if (formValue.Name === "") {
      formValue.Name = "New Activity";
    }
    // **** Edit Or Create ***
    if (this.titleModalActivity === 'Edit Activity') {
      //Date change 20200716T12:36:00 12:36
      let date = formValue.StartDateTime.substr(0, 8) + ' ' + HourToedit;
      formValue.StartDateTime = date;
      formValue = { CusomerActivityId: this.TMPCusomerActivityId, ...formValue };
      this.newActivity(formValue);

      console.log('Edit Form', formValue);
    } else {
      console.log('New Form', formValue);
      this.newActivity(formValue);
      this.initForm();
      this.action.next({success: true, data: 'ok'});

    }
  }
  newActivity(data) {
    this.customerService.PostInsertUpdateCustomerActivity(data).subscribe(
      data => {
        console.log(data)
        if (data[0].ID) {
          if (this.titleModalActivity === 'Edit Activity') {
            this.toast.success(this.translate.instant('msgActEdiSucc'));
          } else {
            this.toast.success(this.translate.instant('msgAcCreSucc'));
            this.action.next({success: true, data: data[0].Result});

          }
        } else {
          if (data[0].ReturnId) {
            if (this.titleModalActivity === 'Edit Activity') {
              this.toast.success(this.translate.instant('msgActEdiSucc'));
              this.action.next({success: true, data: data[0].Result});

            }
          } else {
            this.toast.error('Error Creating Activity');
          }
        }
        // this.getActivityByCustumer();
      },
      err => {
        console.log(err)
      }
    )
  }
}
